<template>
  <div>
    <div v-if="state === 'initial'">
      <div class="grid-x grid-padding-x align-center-middle mini-space">
        <div class="cell medium-6">
          {{ $t('side') }}
        </div>
        <div class="cell medium-6">
          <select v-model="side" style="margin: 0px">
            <option value="top">
              {{ $t('top') }}
            </option>
            <option value="bottom">
              {{ $t('bottom') }}
            </option>
          </select>
        </div>
      </div>
      <div class="grid-x grid-padding-x align-center-middle mini-space">
        <div class="cell medium-12">
          {{ $t('intro') }}
        </div>
      </div>
      <div class="grid-x grid-padding-x align-center-middle mini-space">
        <div class="cell medium-12 text-center">
          <button
            type="button"
            @click="start"
            class="button primary large"
            v-if="currentPart"
          >
            {{ $t('start') }}
          </button>
          <b v-else>{{ $t(side) }} {{ $t('nothing_to_place') }}</b>
        </div>
      </div>
    </div>
    <div v-if="state === 'assembly'">
      <div class="grid-x grid-padding-x align-center-middle text-center mini-space">
        <div class="cell medium-12">
          <div class="progress">
            <progress max="100" :value="progress" />
            {{ $t('part') }} {{ position + 1 }} {{ $t('of') }} {{ total }}
          </div>
        </div>
      </div>
      <hr class="subtle--full">
      <div class="grid-x grid-padding-x mini-space">
        <div class="cell medium-2 text-left">
          <button type="button" @click="previousChunk" class="button small secondary">
            <i class="fas fa-chevron-left" />
          </button>
        </div>
        <div class="cell medium-8">
          <b>{{ currentPart.description }}</b>
          <span v-if="currentPart.mpn">({{ currentPart.mpn }})</span>
        </div>
        <div class="cell medium-2 text-right">
          <button type="button" @click="confirmChunk" class="button small primary">
            <i class="fas fa-check" />
          </button>
        </div>

        <div class="cell medium-2">
          <ul v-for="part in currentPart.placements[side][chunk]" :key="part.id">
            <li>{{ part.name }}</li>
          </ul>
        </div>
        <div class="cell medium-12 text-center mini-space" v-if="chunksAvailable">
          {{ $t('chunk') }} {{ chunk + 1 }} {{ $t('of') }} {{ currentPart.placements[side].length }}
        </div>
      </div>
    </div>
    <div v-if="state === 'done'">
      <div class="grid-x grid-padding-x align-center-middle text-center mini-space">
        <div class="cell medium-12">
          <b>{{ $t('done') }}</b>
        </div>
      </div>
      <div class="grid-x grid-padding-x align-center-middle text-center space">
        <div class="cell medium-12">
          <button type="button" @click="reset" class="button primary large">
            {{ $t('reset') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { components } from 'locales';

export default {
  name: 'SmartGuide',
  props: {
    parts: Array,
    projectToken: String,
  },
  data() {
    return {
      bus: this.$root.bus,
      position: 0,
      side: 'top',
      chunk: 0,
      state: 'initial',
    };
  },
  computed: {
    currentPart() {
      return this.partsBySide[this.position];
    },
    total() {
      return this.partsBySide.length;
    },
    progress() {
      return (100.0 / this.partsBySide.length) * (this.position + 1);
    },
    partsBySide() {
      return this.parts.filter((part) => part.placements[this.side].length > 0);
    },
    chunksAvailable() {
      return this.currentPart.placements[this.side].length > 1;
    },
  },
  mounted() {
  },
  methods: {
    updateViewer() {
      const self = this;
      let placed = [];
      this.partsBySide.forEach((part, ixPart) => {
        if (self.position === ixPart) {
          part.placements[this.side].forEach((chunk, ixChunk) => {
            if (self.chunk === ixChunk) {
              self.bus.emit('updatePartFocus', { parts: chunk, updateCamera: true });
            }
          });
        } else if (self.position > ixPart) {
          part.placements[this.side].forEach((chunk) => {
            placed = placed.concat(chunk);
          });
        }
      });
      self.bus.emit('updatePartPlacement', placed);
    },
    confirmChunk() {
      if ((this.currentPart.placements[this.side].length - 1) === this.chunk) {
        if (this.partsBySide.length === this.position + 1) {
          this.state = 'done';
          this.bus.emit('updatePartFocus', { parts: [], updateCamera: false });
          this.bus.emit('changePerspective', this.side === 'top' ? 'front' : 'back');
          this.position = 0;
          this.chunk = 0;
        } else {
          this.chunk = 0;
          this.position += 1;
          this.updateViewer();
        }
      } else {
        this.chunk += 1;
        this.updateViewer();
      }
    },
    previousChunk() {
      if (this.chunk >= 1) {
        this.chunk -= 1;
      } else if (this.position >= 1) {
        this.position -= 1;
      }
      this.updateViewer();
    },
    handleKeyEvents(evt) {
      if (this.state === 'done') return;

      switch (evt.key) {
        case ' ':
        case 'n':
          this.confirmChunk();
          break;
        case 'b':
          this.previousChunk();
          break;
        default:
          break;
      }
    },
    start() {
      this.state = 'assembly';
      window.addEventListener('keypress', this.handleKeyEvents);
      this.updateViewer();
    },
    reset() {
      this.state = 'initial';
      window.removeEventListener('keypress', this.handleKeyEvents);
      this.bus.emit('updatePartPlacement', []);
    },
    localStorageKey(key) {
      return ['project', this.projectToken, 'guide', key].join('_');
    },
  },
  i18n: components.boards.Guide,
};
</script>

<style scoped lang="scss">
</style>
